import ArchiveLayout from '@/layouts/ArchiveLayout';
import { GUIDES_QUERY } from '@/lib/wordpress';

type Locale = 'en' | 'el';

const title: Record<Locale, string> = {
  en: 'Guides',
  el: 'Οδηγοί',
};

const description: Record<Locale, string> = {
  en: 'Step-by-step guides to help you navigate complex topics.',
  el: 'Οδηγοί βήμα-βήμα για να σας βοηθήσουν να πλοηγηθείτε σε πολύπλοκα θέματα.',
};

const eyebrow: Record<Locale, string> = {
  en: 'GUIDES',
  el: 'ΟΔΗΓΟΙ',
};

const emptyState: Record<Locale, string> = {
  en: 'No guides available at the moment.',
  el: 'Δεν υπάρχουν διαθέσιμοι οδηγοί αυτή τη στιγμή.',
};

const ctaText: Record<Locale, string> = {
  en: 'Contact us',
  el: 'Επικοινωνήστε μαζί μας',
};

export default function GuidesArchive() {
  return (
    <ArchiveLayout
      pageKey="guides"
      postType="guides"
      query={GUIDES_QUERY}
      title={title}
      description={description}
      eyebrow={eyebrow}
      emptyState={emptyState}
      ctaText={ctaText}
    />
  );
}
